import React from "react";
import useDeviceType from "../../../custom-hooks/DeviceType";
import EventEHRLinkTextWithIcon from "../../Atoms/link-text-with-icon/EventEHRLinkTextWithIcon";
import { goToIcon } from "../../../assets";
import { TEXT_CONSTANTS } from "../../../utils/text-constants/textConstants";
import EventEHRImageAvatar from "../../Atoms/image-avatar/EventEHRImageAvatar";
import { getHealthHistory } from "../../../utils/healthHistoryApiLink";
import { useDispatch } from "react-redux";

interface EventEHRPatientProfileDetailCardProps {
  patientDetails: any;
  isOpenHealthHistoryPresent?: any;
  patientId?: any;
}

const EventEHRPatientProfileDetailCard = ({
  patientDetails,
  isOpenHealthHistoryPresent = false,
  patientId,
}: EventEHRPatientProfileDetailCardProps) => {
  const deviceType = useDeviceType();
  const dispatch = useDispatch();

  const borderRadiusOtherThanDesktopScreen =
    deviceType === "mobile" ||
    deviceType === "tablet" ||
    deviceType === "small-tablet";

  const fullName =
    patientDetails[0]?.patientData.find(
      (detail: any) => detail.label === "Full Name"
    )?.value || "";

  return (
    <div
      className={`flex items-center border-radius-8px ${deviceType === "mobile" ? "gap-4" : "gap-[60px]"} w-full`}
    >
      {deviceType != "mobile" && (
        <EventEHRImageAvatar
          labelText={fullName}
          image={patientDetails?.[0]?.userProfileImage}
          commonStyle={{
            width: "60px",
            height: "60px",
            objectFit: "cover",
            border: "1px solid #BCBCBC",
            borderRadius: "8px",
          }}
        />
      )}
      <div
        className={`patient-details-card`}
        style={{
          display: "grid",
          rowGap: "20px",
          columnGap: "10px",
          gridTemplateColumns:
            deviceType === "mobile"
              ? "1fr"
              : deviceType === "small-tablet"
                ? "1fr 1fr"
                : deviceType === "tablet"
                  ? "1fr 1fr 1fr 1fr"
                  : ` ${!isOpenHealthHistoryPresent ? "1fr 1fr 1fr 1fr 1fr 1fr" : "1fr 1fr 1fr 1fr 1fr 1fr"} `,
        }}
      >
        {patientDetails?.[0]?.patientData?.map((data: any, index: number) => (
          <div
            key={index}
            className={` flex flex-col flex-1 gap-2 px-6  ${borderRadiusOtherThanDesktopScreen ? "" : "border-e-2"} ${deviceType === "mobile" ? "my-2 px-0" : ""} ${(deviceType === "small-tablet" || deviceType === "tablet" || deviceType === "mobile") && "mb-2"}`}
          >
            <div className="font-size-14px font-weight-500 color-727272">
              {data?.label}
            </div>
            <div className="color-393939 font-weight-500">{data?.value}</div>
          </div>
        ))}
        {isOpenHealthHistoryPresent && (
          /* No explicit height: this is a grid item, so it already stretches
             to its row. `-webkit-fill-available` resolved against an ancestor
             in WebKit and inflated the whole card on iPad. */
          <div
            className={` flex flex-col flex-1 gap-2 px-6 mb-2 justify-center ${deviceType === "mobile" ? "my-2 px-0" : ""}   `}
          >
            <EventEHRLinkTextWithIcon
              handleClickEvent={() => {
                getHealthHistory(patientId, dispatch);
              }}
              linkText={TEXT_CONSTANTS?.OPEN_HEALTH_HISTORY}
              imageSrc={<img src={goToIcon} alt="goto icon" />}
              labelCustomStyle={{
                fontWeight: 500,
                fontSize: "16px",
                color: "#005596",
                cursor: "pointer",
              }}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default EventEHRPatientProfileDetailCard;
